 document.addEventListener('DOMContentLoaded', function () {
    const qtyMessage = document.querySelector('.trackqty');
    const qtyNumber = document.querySelector('.trackqty .noqty');
    const errorSlot = document.getElementById('custom-error-message-slot');
    const productForm = document.querySelector('.product-form');
    const submitButton = productForm?.querySelector('.product-form__submit');

    let lastErrorText = '';
    let debounceTimer = null;

    function updateQtyMessage(variantId) {
      const inventoryQty = window.variantInventory?.[variantId];

      if (inventoryQty == 1) {
        qtyNumber.textContent = '1';
        qtyMessage.style.display = 'block';
        checkMaxInCart(variantId, inventoryQty);
      } else {
        qtyMessage.style.display = 'none';
        errorSlot.innerHTML = '';
        enableSubmit();
      }
    }

    function checkMaxInCart(variantId, inventoryQty) {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartItem = cart.items.find(item => item.id == variantId);
          const quantityInCart = cartItem ? cartItem.quantity : 0;

          if (inventoryQty == 1 && quantityInCart >= 1) {
            // Max quantity already in cart
            showCustomError('<div class="over-qty-msg"><h3><span>i</span>You have reached the maximum quantity.</h3><p>Oops! An order cannot contain the same item more than twice. We invite you to reduce the quantity ordered</p></div>');
            disableSubmit();
          } else {
            // Item not at max in cart
            errorSlot.innerHTML = '';
            enableSubmit();
          }
        });
    }
   

    function showCustomError(msg) {
      const errorHTML = `
        <div class="product-form__error-message-wrapper" role="alert">
          <span class="svg-wrapper">
            ${window.Shopify && Shopify.icons ? Shopify.icons.error : ''}
          </span>
          <span class="product-form__error-message">${msg}</span>
        </div>
      `;
      errorSlot.innerHTML = errorHTML;
    }

    function disableSubmit() {
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('disabled');
      }
    }

    function enableSubmit() {
      if (submitButton) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('disabled');
      }
    }

    function initVariantListeners() {
      const variantSelect = document.querySelector('form[action^="/cart/add"] select[name="id"]');
      if (variantSelect) {
        variantSelect.addEventListener('change', function (e) {
          updateQtyMessage(e.target.value);
        });
        updateQtyMessage(variantSelect.value);
      }

      document.querySelectorAll('form[action^="/cart/add"] input[name="id"]').forEach(radio => {
        radio.addEventListener('change', function () {
          updateQtyMessage(radio.value);
        });
        if (radio.checked) {
          updateQtyMessage(radio.value);
        }
      });
    }

    function observeErrorMessages() {
      if (!productForm || !errorSlot) return;

      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          const originalErrorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          const errorMessageEl = originalErrorWrapper?.querySelector('.product-form__error-message');

          if (!originalErrorWrapper || !errorMessageEl) return;

          const isVisible = !originalErrorWrapper.hasAttribute('hidden');
          const errorText = errorMessageEl.textContent.trim();

          if (isVisible && errorText && errorText !== lastErrorText) {
            const clonedWrapper = originalErrorWrapper.cloneNode(true);
            clonedWrapper.removeAttribute('hidden');
            errorSlot.innerHTML = '';
            errorSlot.appendChild(clonedWrapper);
            lastErrorText = errorText;
          } else if (!isVisible || !errorText) {
            errorSlot.innerHTML = '';
            lastErrorText = '';
          }
        }, 100);
      });

      observer.observe(productForm, {
        childList: true,
        subtree: true
      });
    }

    initVariantListeners();
    observeErrorMessages();
  });